import { useThemeColors } from "../context/ThemeColorContext";
import { ThemeContext } from "../context/ThemeContext";
import { useContext } from "react";
import { useStaticTexts } from "../context/StaticTextContext";
import {
  Github,
  Linkedin,
  Instagram,
  Send,
} from "lucide-react"; // آیکون‌های Lucide

const Footer = () => {
  const { darkMode } = useContext(ThemeContext);
  const { lightPrimary, darkPrimary, lightText } = useThemeColors();
  const staticTexts = useStaticTexts();

  if (!staticTexts || Object.keys(staticTexts).length === 0) return null;

  const {
    footer_text,
    telegram_link,
    instagram_link,
    linkedin_link,
    github_link,
  } = staticTexts;

  const iconColor = darkMode ? "#bbb" : lightText;
  // const hoverColor = darkMode ? "#fff" : "#333";

  const socialLinks = [
    { icon: <Send />, href: telegram_link },
    { icon: <Instagram />, href: instagram_link },
    { icon: <Linkedin />, href: linkedin_link },
    { icon: <Github />, href: github_link },
  ];

  return (
    <footer
      className="text-center text-sm py-6 border-t mt-8"
      style={{
        backgroundColor: darkMode ? darkPrimary : lightPrimary,
        color: iconColor,
      }}
    >
      <div className="flex justify-center gap-5 mb-4">
        {socialLinks.map(
          (link, idx) =>
            link.href && (
              <a
                key={idx}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:scale-110"
                style={{ color: iconColor }}
              >
                {link.icon}
              </a>
            )
        )}
      </div>
      <p style={{ color: iconColor }}>{footer_text}</p>
    </footer>
  );
};

export default Footer;
